import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricCtrBing extends MetricBase {
    constructor() {
        super({
            field: "metric_ctr",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.ctr.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.ctr.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.ctr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCtrBing;
